import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from "yup";
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';

export default function StudentFacultyRatio() {

    const [getRatio, setRatio] = useState([])
    const [isSubmitted, setIsSubmitted] = useState(false);

    /* ================= VALIDATION ================= */
    const validationSchema = Yup.object({
        ratioList: Yup.array().of(
            Yup.object().shape({
                remarks: Yup.string()
                    .required("Remarks is required")
                    .min(3, "Remarks must be at least 3 characters")
                    .max(200, "Remarks cannot exceed 200 characters")
            })
        )
    });

    /* ================= API 1 ================= */
    function getStudentFaculatyRatioFunc() {
        let url = config.url.FAC_URL + "getStudentFacRatio";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                setRatio(res?.data?.ratio || [])
            } else {
                setRatio([])
            }
        })
    }

    useEffect(() => {
        getStudentFaculatyRatioFunc()
    }, [])

    /* ================= INITIAL VALUES ================= */
    const getInitialValues = () => ({
        ratioList: getRatio.map(() => ({
            remarks: ""
        }))
    });

    /* ================= FORMIK ================= */
    const formik = useFormik({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values) => {
            submitStdFcltRatio(values)
        }
    });

    /* ================= SUBMIT ================= */
    function submitStdFcltRatio(values) {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit Student–Faculty Ratio details?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "No, Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.FAC_URL + "saveStdFacRatio"
                const payload = {
                    studentFacultyRatio: getRatio.map((item, index) => ({
                        courseId: item.course_id,
                        courseName: item.course_name,
                        intake: item.intake,
                        facultyCount: item.no_of_fac,
                        studentFacultyRatio: item.simplified_ratio ?? "0",
                        remarks: values.ratioList[index].remarks
                        // studentFacultyRatio: item.simplified_ratio ?? "0"
                    }))
                }

                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlert2(res.data.sdesc)
                        getFinalRatioData();
                    } else {
                        failureAlert(res?.data?.sdesc)
                    }
                })
            }
        });
    }

    /* ================= FINAL DATA ================= */
    const [finalData, setFinalData] = useState([]);

    function getFinalRatioData() {
        const url = config.url.FAC_URL + "getStudentFacultyRatio";

        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status === true && res.data.getStdFacRatio_status) {
                    const data = res.data.getStdFacRatio;
                    setFinalData(data);

                    const isAlreadySubmitted = data.every(
                        item => item.remarks && item.remarks.trim() !== ""

                    );
                    setIsSubmitted(isAlreadySubmitted);
                    data.forEach((item, index) => {
                        formik.setFieldValue(`ratioList.${index}.remarks`, item.remarks || "");
                    });
                } else {
                    setFinalData([]);
                    setIsSubmitted(false);
                }
            })
            .catch(() => {
                setFinalData([]);
                setIsSubmitted(false);
            });
    }

    useEffect(() => {
        if (getRatio.length > 0) {
            getFinalRatioData();
        }
    }, [getRatio])

    /* ================= UI ================= */
    return (
        <Container fluid className="py-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    <h5 className="mb-3 innerheader-new text-success">
                        <span>Student Faculty Ratio (SFR)</span>
                    </h5>
                    {/* <h5 className="mb-3 innerheader-new">
                        <span>Laboratories: For the proposed intake</span>
                    </h5> */}
                    <Row className="mt-4">
                        {/* <Col xs={12}>


                            <Table bordered responsive>
                                <thead className='table-primary'>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Course</th>
                                        <th>Intake (S)</th>
                                        <th>Faculty (F)</th>
                                        <th>SFR</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {getRatio.length > 0 ? getRatio.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ width: "10px" }}>{index + 1}</td>
                                            <td>{item.course_name || "-"}</td>
                                            <td className="text-end">{item.intake ?? "-"}</td>
                                            <td className="text-end">{item.no_of_fac ?? "-"}</td>
                                            <td className="text-end">{item.ratio ?? "-"}</td>

                                            <td>
                                                <Field
                                                    as="textarea"
                                                    name={`ratioList.${index}.remarks`}
                                                    className="form-control"
                                                    rows={3}
                                                    placeholder="Enter remarks"
                                                    disabled={isSubmitted}
                                                    onBlur={formik.handleBlur}
                                                />
                                                <ErrorMessage
                                                    name={`ratioList.${index}.remarks`}
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="6" className="text-center text-danger">
                                                ***** No Data Found *****
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </Table>
                            <div className="mt-3">
                                <p className="mb-1 text-danger fs-3"><b>Note:</b></p>
                                <p className="mb-1 ">
                                    <b>S</b> - Sum of students as per Approved Intake
                                </p>
                                <p className="mb-0 ">
                                    <b>F</b> - Sum of faculty in department
                                </p>
                            </div>

                            {getRatio.length > 0 && (
                                isSubmitted ? (
                                    <p className="text-success fw-bold mt-2 text-end">
                                        ✅ Already Submitted
                                    </p>
                                ) : (
                                    <Row className="mt-4">
                                        <Col xs={12} className="text-end">
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        </Col>
                                    </Row>
                                )
                            )}
                        </Col> */}
                        <Col xs={12}>
                            {getRatio.length === 0 ? (
                                // <div className="text-center text-danger fw-bold mt-4">
                                //     ***** No Data Found *****
                                // </div>
                                <center className="text-danger mt-4 h5">
                                    {" "}
                                    ***** No Data Found *****{" "}
                                </center>
                            ) : (
                                <>
                                    <Table bordered responsive>
                                        <thead className='table-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Academic Program Type</th>
                                                <th>Course / Program</th>
                                                <th>Branch / Specialization</th>
                                                <th>Intake (S)</th>
                                                <th>Faculty (F)</th>
                                                <th>SFR</th>
                                                <th>Remarks</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {getRatio.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ width: "10px" }}>{index + 1}</td>
                                                    <td>{item.course_group_desc || "-"}</td>
                                                    <td>{item.course_cat_name || "-"}</td>
                                                    <td>{item.course_name || "-"}</td>
                                                    <td className="text-end">{item.intake ?? "-"}</td>
                                                    <td className="text-end">{item.no_of_fac ?? "-"}</td>
                                                    <td className="text-end">{item.ratio ?? "-"}</td>

                                                    <td>
                                                        <Field
                                                            as="textarea"
                                                            name={`ratioList.${index}.remarks`}
                                                            className="form-control"
                                                            rows={3}
                                                            placeholder="Enter remarks"
                                                            disabled={
                                                                finalData[index]?.remarks !== null &&
                                                                finalData[index]?.remarks !== ""
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        <ErrorMessage
                                                            name={`ratioList.${index}.remarks`}
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                    {/* Note */}
                                    <div className="mt-3">
                                        <b className="mb-1 text-danger fs-3">Note:</b> &emsp;
                                        <b>S</b> - Sum of students as per Approved Intake  &emsp;

                                        <b>F</b> - Sum of faculty in department


                                    </div>

                                    {/* Submit */}
                                    {isSubmitted ? (
                                        <p className="text-success fw-bold mt-2 text-end">
                                            ✅ Already Submitted
                                        </p>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col xs={12} className="text-end">
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </Container>
    )
}